import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=0c1ba31e&"
import script from "./UserSearch.vue?vue&type=script&lang=ts&"
export * from "./UserSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports